import i18n from '../i18n';

export interface StaticList {
  id?: string;
  name: string;
}

export const productionSystemChoices: StaticList[] = [
  { id: 'open_field', get name() { return i18n.t('Open field')(); } },
  { id: 'plastic_tunnel', get name() { return i18n.t('Plastic tunnel')(); } },
  { id: 'glasshouse', get name() { return i18n.t('Glasshouse')(); } },
  { id: 'hydroponics', get name() { return i18n.t('Hydroponics')(); } },
];

export const croppingSystemChoices: StaticList[] = [
  { id: 'continuous_monocrop', get name() { return i18n.t('Continuous monocrop')(); } },
  { id: 'rotated_intercrop', get name() { return i18n.t('Rotated intercrop')(); } },
  {
    id: 'intercrop_mixed_cropping',
    get name() { return i18n.t('Intercrop mixed cropping')(); },
  },
];

export const marketScaleChoices: StaticList[] = [
  { id: 'households', get name() { return i18n.t('Households')(); } },
  { id: 'local', get name() { return i18n.t('Local')(); } },
  { id: 'regional', get name() { return i18n.t('Regional')(); } },
  { id: 'national', get name() { return i18n.t('National')(); } },
  { id: 'international_markets', get name() { return i18n.t('International markets')(); } },
];

export const tppStatesChoices: StaticList[] = [
  { id: 'active', get name() { return i18n.t('Active')(); } },
  { id: 'discarded', get name() { return i18n.t('Discarded')(); } },
  { id: 'completed', get name() { return i18n.t('Completed')(); } },
];
